/** Labels canônicos do Financeiro da plataforma — copy e glossário. */

export const FINANCE_LABEL = {
  mrrPortfolio: "MRR carteira",
  mrrDre: "Receita recorrente (DRE)",
  revenueSaas: "Receita SaaS",
  revenueConsolidated: "Receita consolidada",
  ebitdaManagerial: "EBITDA gerencial",
  netSaas: "Resultado líquido SaaS",
  netConsolidated: "Resultado líquido consolidado",
  cashGeneration: "Geração de caixa (realizado)",
  cashStock: "Caixa no balanço",
  cashForecast: "Líquido previsto",
  commercialGoals: "Metas comerciais",
  bonusGoals: "Metas de bônus",
  headcountReported: "Quadro informado",
  headcountPeople: "Pessoas no ciclo",
  dso: "DSO (prazo médio de recebimento)",
  cmv: "CMV (custo do serviço)",
  arpu: "ARPU (receita média por cliente)",
  save: "Salvar",
  savePayouts: "Simular payouts da competência",
  closeCycle: "Fechar ciclo",
  leading: "Antecedente (meio)",
  lagging: "Resultado (fim)",
  meta: "Meta",
  super: "Super",
  hiper: "Hiper",
  resultRules: "Réguas do canal",
  participation: "Participação no resultado",
  resultWindow: "Janela de resultado",
  growthPrize: "Prêmio de crescimento",
  attributedResult: "Resultado atribuído",
  payoutOnResult: "Payout ligado ao resultado",
  myResults: "Meus resultados",
  monthReport: "Relatório do mês",
  contractClt: "CLT",
  contractPj: "PJ",
  remuneration: "Remuneração",
  leadershipBonus: "Gratificação",
  bonusBase: "Base do bônus",
  teamSales: "Vendas do time",
  teamRules: "Réguas do time",
  channelPortfolio: "Carteira do canal",
  exportPdfPerson: "Exportar PDF",
  exportPdfAll: "Exportar PDFs de todos",
};

export const FINANCE_GLOSS = {
  mrrPortfolio: "Receita recorrente da carteira de clientes ativos no snapshot — não é a linha MRR do DRE.",
  cashGeneration: "Entradas menos saídas já liquidadas no período (mesmo critério do Fluxo realizado).",
  cashStock: "Saldo de caixa e equivalentes na data do balanço (estoque, não fluxo).",
  commercialGoals: "Grade mensal de MRR, crescimento e margem bruta (Meta / Super / Hiper). Não dispara bônus.",
  bonusGoals: "Régua anual 80 / 100 / 120 do gatilho corporativo. Abaixo de 80% zera o bônus interno.",
  superHiper: "Meta = 100% do plano do mês. Super = acima da meta. Hiper = meta esticada.",
  leadingLagging: "Resultado (fim) mede o que já aconteceu. Antecedente (meio) mede o que antecipa o resultado.",
  ebitda: "Resultado operacional SaaS (sem depreciação/amortização explícita no plano gerencial).",
  gtmVsProfile:
    "Trilha de pagamento (como a plataforma remunera o canal) é independente do perfil do portal do representante. Associação ou montadora podem nascer sem participação — e isso se liga na elegibilidade, sem travar override.",
  resultSpeaks:
    "Canal (representantes): payout recorrente sobre o MRR da carteira. Time: comissão mensal por 12 meses sobre a margem da empresa no catálogo.",
  resultRules:
    "Régua do canal = participação %, janela em meses, royalty e prêmio de crescimento por trilha (revenda, franquia, indicação, aliança).",
  participation: "Percentual do resultado (MRR) que o representante recebe enquanto estiver na janela.",
  resultWindow: "Quantos meses a partir do início a participação vale. Vazio = recorrente enquanto houver resultado.",
  growthPrize: "Extra sobre o resultado quando a carteira cresce vs. o mês anterior.",
  poolCap:
    "Teto do pool do canal: a soma das partes do deal não pode passar do percentual configurado sobre o resultado.",
  teamSalesIntro:
    "Lance a venda do time. A comissão é mensal por 12 meses sobre a margem da empresa (MRR − CMV − impostos). Escolha o tipo certo: contrato novo, aditivo (nova assinatura) ou upgrade (delta após migração).",
  teamSalesHint:
    "Base = margem empresa (MRR − CMV − impostos), não o MRR cheio. Novo cliente = contrato novo. Nova assinatura = aditivo em cliente que já existe (só essa assinatura). Upgrade = migre o plano no workspace e selecione o plano anterior para comissionar só o delta. Closer obrigatório; indicador opcional.",
  saleKindNew:
    "Contrato novo com um cliente que ainda não tinha assinatura ativa no Xpro. A base é a margem total do portfólio sincronizado.",
  saleKindAddon:
    "Cliente já existente ganhou uma assinatura adicional (aditivo). Não é “novo cliente”. Selecione só a assinatura nova — a comissão não inclui o restante do portfólio.",
  saleKindUpgrade:
    "1) Migre/sincronize o plano no workspace. 2) Se houver mais de uma assinatura, escolha qual sofreu o upgrade. 3) Selecione o plano anterior — a comissão é só o delta (margem da assinatura − margem anterior).",
  saleKindNewLabel: "Novo cliente (contrato novo)",
  saleKindAddonLabel: "Nova assinatura (cliente existente)",
  saleKindUpgradeLabel: "Upgrade / migração de plano",
  teamRulesIntro:
    "Régua do time: % mensal sobre a margem da venda, pago em até 12 competências. Gestor recebe % da parcela do liderado.",
  teamRulesHint:
    "Padrão de mercado: closer 10%, indicador 5%, gestor 20% da comissão do liderado, 12 meses. Vazio na pessoa = usa o padrão. Demissão/distrato ou churn do cliente cortam só o futuro.",
  teamVestingRules:
    "12 parcelas mensais. Pessoa inativa (demissão CLT ou distrato PJ) ou cliente cancelado: parcelas futuras são perdidas; valores já creditados não são estornados.",
  channelPortfolioIntro:
    "Ranking recorrente dos representantes: MRR atribuído na competência e payout da régua do canal.",
  channelRulesIntro:
    "Réguas e elegibilidade do canal (representantes). Independente das comissões do time interno.",
  myResultsIntro:
    "Parcelas creditadas nesta competência. Futuras dependem de você continuar no time e do cliente permanecer ativo.",
  monthReportIntro:
    "Visão consolidada das parcelas creditadas do time na competência. Exporte o PDF por pessoa para anexar ao ERP e enviar para conferência.",
  monthReportHint:
    "Cada PDF segue o padrão XVISION (capa azul, tabelas e rodapé confidencial). Um arquivo por pessoa — ideal para lançamento e envio individual.",
  eligibility:
    "Por tipo de parceiro (revenda, associação, montadora…): liga ou desliga participação e prêmio. Override por representante é permitido.",
  peopleContract:
    "CLT: salário + gratificação de liderança (quando houver) entram na base do bônus. PJ: só a remuneração contratada — sem gratificação CLT.",
  peopleBonusBase:
    "A base do bônus interno é a remuneração mensal usada na fórmula. Em CLT com liderança, soma salário + gratificação.",
  peopleBand:
    "Faixa define o teto de salários no bônus (ex.: analista até 3× a base). Não é o cargo jurídico — é a régua do ciclo.",
  peopleInherit:
    "Quem herda o cartão usa as metas do gestor (comum em júnior/estagiário). O bônus ainda usa a base salarial da própria pessoa.",
  orgAreas:
    "Áreas agrupam o time para cartões e metas. Uma área pode ficar sob outra (ex.: Atendimento → Suporte Avançado).",
  orgAreasParent:
    "Área pai opcional: use para mostrar a estrutura do time. Quem está na área filha continua vinculado só a ela.",
};

export const FINANCE_PERIOD_HINT = {
  year: "Esta vista usa o ano da competência.",
  anchorMonth: "Comissões usam o mês âncora da competência.",
  reference: "O período só entra como referência; premissas ficam neste navegador.",
  cashAlways: "Fluxo de caixa usa sempre regime de caixa.",
  balancePosition: "Balanço é posição patrimonial; o cruzamento com o DRE usa competência. No ano, usa dezembro.",
};
